// extracted by mini-css-extract-plugin
export default {"rescheduleButton":"qXKaYoZ2_trHQHaaKUfg"};